<template>
  <div class="section section-white">
    <el-form ref="form" :model="form" label-position="left" label-width="150px">
      <div class="section-body">
        <template>
          <el-form-item label="自动注销天数：">
              用户将在最后活跃日 <el-input type="number" required min="1" v-model="form.auto_drop_user_days" placeholder="" style="width: 100px;" />天之后注销
          </el-form-item>

        </template>
      </div>
      <div class="section-footer with-border content-center">
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
  import { getUserSetting, setUserSetting } from '@/api/member'
  export default {
    data () {
      return {
          form: {
            auto_drop_user_days: 180,
          },
      }
    },
    methods: {
      save() {
        console.log(this.form)
        setUserSetting(this.form).then(res => {
            this.$message({message: '保存成功', type: 'success'})
        })
      }
    },
    mounted () {
      getUserSetting().then(res => {
        let setting = res.data.data
        if (setting.auto_drop_user_days) {
          this.form.auto_drop_user_days = setting.auto_drop_user_days
        }

      })
    }
  }
</script>
<style scoped lang="scss">
</style>
